

























import {Component, Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import {Editor} from '@tiptap/vue-2';
import IconButton from '@/components/button/IconButton.vue';
import EditorHeading from '@/components/editor/toolbar-basic-button/EditorHeading.vue';
import EditorParagraph from '@/components/editor/toolbar-basic-button/EditorParagraph.vue';
import EditorBold from '@/components/editor/toolbar-basic-button/EditorBold.vue';
import EditorItalic from '@/components/editor/toolbar-basic-button/EditorItalic.vue';
import EditorStrike from '@/components/editor/toolbar-basic-button/EditorStrike.vue';
import EditorHighlight from '@/components/editor/toolbar-basic-button/EditorHighlight.vue';
import EditorFontColor from '@/components/editor/toolbar-basic-button/EditorFontColor.vue';
import EditorCodeLine from '@/components/editor/toolbar-basic-button/EditorCodeLine.vue';
import EditorCodeBlock from '@/components/editor/toolbar-basic-button/EditorCodeBlock.vue';
import EditorHorizontalRule from '@/components/editor/toolbar-basic-button/EditorHorizontalRule.vue';
import EditorBulletList from '@/components/editor/toolbar-basic-button/EditorBulletList.vue';
import EditorOrderedList from '@/components/editor/toolbar-basic-button/EditorOrderedList.vue';
import EditorTaskList from '@/components/editor/toolbar-basic-button/EditorTaskList.vue';
import EditorHyperLink from '@/components/editor/toolbar-basic-button/EditorHyperLink.vue';
import EditorTextLeftAlign from '@/components/editor/toolbar-basic-button/EditorTextLeftAlign.vue';
import EditorTextRightAlign from '@/components/editor/toolbar-basic-button/EditorTextRightAlign.vue';
import EditorTextCenterAlign from '@/components/editor/toolbar-basic-button/EditorTextCenterAlign.vue';

@Component({
  components: {EditorTextCenterAlign, EditorTextRightAlign, EditorTextLeftAlign, EditorHyperLink,
    EditorTaskList, EditorOrderedList, EditorBulletList, EditorHorizontalRule, EditorCodeBlock,
    EditorCodeLine, EditorFontColor, EditorHighlight, EditorStrike, EditorItalic, EditorBold,
    EditorParagraph, EditorHeading, IconButton},
  mixins: [InputMixin]
})
export default class BasicToolbar extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: null}) private editor: Editor;
}
